
import { I18n } from '@front/volcanion'
class PopupCallbacks {
  static onSubmitPackageHandler(setFormState) {
    return async function onSubmitPackage(values, extra, meta, state) {
      const { commercial_package } = values
      setFormState({ commercial_package })
    }
  }
  static onConfirmResetIdentifierHandler(resetIdentifiers, openNotification, setFormValues, isReadOnly, record_id) {
    return async function onConfirmResetIdentifier() {
      try {
        const [companyuser] = await resetIdentifiers({ companyuser_id: record_id })
        !isReadOnly && setFormValues([
          { field: 'identifier', value: companyuser?.identifier },
          { field: 'pin', value: companyuser?.pin }
        ])
        openNotification(I18n.t('identifier.reset.success'), { variant: 'success' })
      } catch (error) {
        console.log(error)
        openNotification(I18n.t('identifier.reset.error'), { variant: 'error' })
      }
    }
  }
}

export default PopupCallbacks


